import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { Strong } from './component';
export default withProvisionalOverrideFromContext(Strong);
//# sourceMappingURL=index.js.map